import React from 'react';
import {NextPage} from 'next';
import Layout from '../../components/layout';
import GenericContainer from '../../components/@container/generic-container';
import Link from '../../components/link';
import useCustomer from "../../hooks/use-customer";

const TrainingMaterialsPage: NextPage = () => {
  const customer = useCustomer();

  return (
    <Layout title="Training Materials">
      <GenericContainer
        title="Training Materials"
        breadcrumb={{ url: '/', text: 'Back to Home' }}
      >
        <div className="content">
          <p>Please choose one of the following options.</p>
          <div className="bookstores">
            <Link href="/training/books">
              <a className="bookstore-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right"/>
              </span>
                Course Books
              </a>
            </Link>
            <Link href="/training/online">
              <a className="bookstore-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right"/>
              </span>
                Online Courses
              </a>
            </Link>
            {!customer?.customer?.guest &&
              <Link href="/training/downloads">
                <a className="bookstore-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right"/>
              </span>
                  Downloads
                </a>
              </Link>
            }
          </div>
        </div>
        {/* languages=CSS */}
        <style jsx>{`
          p {
            font-family: 'Volvo Novum', sans-serif;
          }

          .bookstores {
            display: grid;
            align-items: center;
          }

          .bookstore-tile {
            font-family: 'Volvo Novum', sans-serif;
            font-size: 14px;
            text-decoration: none;
            color: #333;
            padding: 1rem;
            margin-bottom: 0.5rem;
            cursor: pointer;
          }

          .bookstore-tile:hover {
            background-color: #eee;
          }

          .click-icon {
            float: left;
            padding-right: 2rem;
          }
        `}</style>
      </GenericContainer>
    </Layout>
  );
}

export default TrainingMaterialsPage;
